import { Button } from '@repo/ui/components/ui/button'
import { createFileRoute, Link, notFound } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { WebLayout } from '@/components/layout'
import { BlogPostPage } from '@/features/blog'
import { getBlogPost } from '@/features/blog/data'

export const Route = createFileRoute('/blog/$slug')({
  component: BlogPost,
  loader: ({ params }) => {
    const post = getBlogPost(params.slug)
    if (!post) {
      throw notFound()
    }
    return { post }
  },
})

function BlogPost() {
  const { slug } = Route.useParams()

  return (
    <WebLayout>
      <div className="container max-w-4xl mx-auto px-4 py-16">
        {/* Back Link */}
        <Button variant="ghost" asChild className="mb-8 justify-start p-0 h-auto">
          <Link to="/blog" className="inline-flex items-center gap-2 text-sm">
            <ArrowLeft className="w-4 h-4" />
            Back to Blog
          </Link>
        </Button>

        <BlogPostPage slug={slug} />
      </div>
    </WebLayout>
  )
}
